var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";
import { useQuery, useQueryClient } from "react-query";
import apiService from "../services/api";
export const USAGE_QUERY_KEY = "usage-summary";
/** The account's plan, today's usage and credit balance. Refresh after anything that consumes quota. */
export function useUsage(options = {}) {
    var _a;
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();
    const queryClient = useQueryClient();
    const query = useQuery(USAGE_QUERY_KEY, () => __awaiter(this, void 0, void 0, function* () { return apiService.getUsage(yield getAccessTokenSilently()); }), { enabled: isAuthenticated && ((_a = options.enabled) !== null && _a !== void 0 ? _a : true), staleTime: 30 * 1000 });
    const refreshUsage = useCallback(() => queryClient.invalidateQueries(USAGE_QUERY_KEY), [queryClient]);
    return Object.assign(Object.assign({}, query), { usage: query.data, refreshUsage });
}
